export const baseurl = import.meta.env.VITE_BASE_URL;

